const axios = require("axios").default;
import { LICENSE_TYPES } from "../../src/interfaces/IUserInterface";
import { environment_conf } from "../environment";
import { axiosInstanceWithIdentityProviderHeader } from "../axios/axiosInstance";

export const getDomainHint = async (emailAddress) => {
  var resp = await axios.get(
    conf.base_app_domain + `/domainHints/get?email=${emailAddress}`
  );
  return await resp.json();
};

export const getLicense = async () => {
  var baseDomain = environment_conf.base_app_domain;
  var resp = await axiosInstanceWithIdentityProviderHeader.get(
    baseDomain + "/seats/getSeat"
  );
  return resp;
};

export const getAnalysis = async (accessKey, bodyHtml) => {
  return await axios.post(`${environment_conf.base_ai_domain}/analyze`, {
    bodyHtml,
  });
};

export const semanticSearch = async (
  query,
  suggestions_to_retrieve,
  children_levels
) => {
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios.post(
    `${environment_conf.base_ai_domain}/semantic_search`,
    {
      query,
      suggestions_to_retrieve,
      children_levels,
    },
    { headers: headers }
  );
};

export const generateDefinition = async (
  query,
  suggestions_to_retrieve,
  children_levels
) => {
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios.post(
    `${environment_conf.base_ai_domain}/generate_definition`,
    {
      query,
      suggestions_to_retrieve,
      children_levels,
    },
    { headers: headers }
  );
};

export const generateSection = async (
  query_section,
  written_sections,
  suggestions_to_retrieve,
  children_levels
) => {
  const headers = {
    "Content-Type": "application/json",
  };

  return await axios.post(
    `${environment_conf.base_ai_domain}/generate_section`,
    {
      query_section,
      written_sections,
      suggestions_to_retrieve,
      children_levels,
    },
    { headers: headers }
  );
};
